import React from 'react';

/**
 * Shared authenticated page header with optional actions/controls.
 */
export const PageHeader = ({
  icon: Icon,
  title,
  subtitle,
  primaryAction,
  secondaryAction,
  controls,
  className = '',
}) => {
  return (
    <header className={`portalr-pageHeader ${className}`.trim()}>
      <div className="portalr-pageHeaderMain">
        <div className="portalr-pageHeaderTitleWrap">
          {Icon ? (
            <span className="portalr-pageHeaderIcon" aria-hidden="true">
              <Icon size={20} />
            </span>
          ) : null}
          <div>
            <h1 className="portalr-pageHeaderTitle">{title}</h1>
            {subtitle ? <p className="portalr-pageHeaderSubtitle">{subtitle}</p> : null}
          </div>
        </div>
        {(secondaryAction || primaryAction) ? (
          <div className="portalr-pageHeaderActions">
            {secondaryAction}
            {primaryAction}
          </div>
        ) : null}
      </div>
      {controls ? <div className="portalr-pageHeaderControls">{controls}</div> : null}
    </header>
  );
};

